import { createTheme } from "@mui/material/styles";

//This is the css for Material Ui
export const theme = createTheme({
  palette: {
    primary: {
      main: "rgba(84,77,160,1)",
      dark: "rgba(84,77,160,0.7)",
      light: "rgba(84,77,160,0.1)",
    },
    secondary: {
      main: "#ffffff",
    },
    customColors: {
      teal: 'rgb(0, 160, 160)',
      tealLight: 'rgba(0, 160, 160, 0.6)',
      tealDark: 'rgba(0, 160, 160, 0.9)',
    },
    action: {
      active: "#ffffff",
    },
    grey: {
      "600": "#808080",
      "800": "#000000",
    },
    text: {
//      primary: "#c14f00",
      primary: "#00a0a0",
      secondary: "rgb(0, 160, 160)",
      disabled: "#efefef",
    },
  },
  typography: {
    fontFamily: "Roboto, sans-serif",
    h1: {
      fontSize: "2.2rem",
    },
    h2: {
      fontSize: "2rem",
    },
    h3: {
      fontSize: "1.5rem",
    },
    h4: {
      fontSize: "1.25rem",
    },
    h5: {
      fontSize: "1rem",
    },
    body1: {
      fontSize: "0.875rem",
    },
    body2: {
      fontSize: "0.8125rem",
    },
    subtitle1: {
      fontSize: "0.65rem",
    },
    subtitle2: {
      fontSize: "1rem",
    },
  },
});
